import './App.css';
import Temp from './components/temp';

function App() {
  return (
   <div>
     <Temp/>
    </div>
  );
}

export default App;
